import request from '@/utils/request'

let cardApi = {
  /*名片列表*/
  cardList(data) {
    return request._post('/shop/plus.card.CardList/index', data);
  },
  /*添加名片*/
  addCard(data) {
    return request._post('/shop/plus.card.CardList/add', data);
  },
  /*获取名片数据*/
  getCard(data) {
    return request._get('/shop/plus.card.CardList/edit', data);
  },
  /*保存名片*/
  saveCard(data) {
    return request._post('/shop/plus.card.CardList/edit', data);
  },
  /*删除名片*/
  delCard(data) {
    return request._post('/shop/plus.card.CardList/delete', data);
  },
  /*查看商品*/
  seeCard(data) {
    return request._post('/shop/plus.card.CardList/see', data);
  },
  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.card.Setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.card.Setting/index', data);
  },
  /*获取供应商列表*/
  getSupplyList(data) {
    return request._get('/shop/plus.card.CardList/add', data);
  },
  /*
  *编辑名片信息获取
  */
  getCardInfo(data) {
    return request._get('/shop/plus.card.CardList/edit', data);
  },
  editCard(data) {
    return request._post('/shop/plus.card.CardList/edit', data);
  },
  /* 查看名片码 */
  showCode(data) {
    return request._post('/shop/plus.card.CardList/showCode', data);
  },

   /* 查看名片分类 */
  categoryList(data) {
    return request._get('/shop/plus.card.Category/categoryList', data);
  },
  /* 添加名片分类 */
  addCategory(data) {
    return request._post('/shop/plus.card.Category/add', data);
  },

  editCategory(data) {
    return request._post('/shop/plus.card.Category/edit', data);
  },
  delCategory(data) {
    return request._post('/shop/plus.card.Category/delete', data);
  },
  getCategoryList(data) {
    return request._get('/shop/plus.card.CardList/getCategoryList', data);
  },
  supplyList(data) {
    return request._get('/shop/plus.card.CardAuth/index', data);
  },
  editCardAuth(data){
    return request._post('/shop/plus.card.CardAuth/edit', data);
  },
  gradelist(data){
    return request._post('/shop/plus.card.CardAuth/grade', data);
  },
  addGrade(data){
    return request._post('/shop/plus.card.CardAuth/editGrade', data);
  },
  editGrade(data){
    return request._post('/shop/plus.card.CardAuth/editGrade', data);
  },
  deletegrade(data){
    return request._post('/shop/plus.card.CardAuth/delGrade', data);
  },
  cardGradeOrderList(data){
    return request._post('/shop/plus.card.CardList/cardGradeOrderList', data);
  },
}
export default cardApi;



// WEBPACK FOOTER //
// ./src/api/card.js